import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";

const ImageSection = ({ imageId, image, formToken, chatId, allowGeneration = true }) => {
  const [imageUrl, setImageUrl] = useState(image);
  const [status, setStatus] = useState(image ? "ready" : "idle");
  const [errorMessage, setErrorMessage] = useState("");

  const requestImage = useCallback(async () => {
    if (!imageId || !allowGeneration) return;

    setStatus("loading");
    setErrorMessage("");

    try {
      const response = await axios.post(
        `/api/v1/chats/${chatId}/generate_image`,
        { chat_image_id: imageId },
        {
          headers: {
            Authorization: `Bearer ${formToken}`,
          },
        }
      );
      setImageUrl(response.data.imageUrl);
      setStatus("ready");
    } catch (error) {
      console.error("Error generating image:", error);
      setStatus("error");
      setErrorMessage("Illustration is taking longer than usual. Try again?");
    }
  }, [allowGeneration, chatId, formToken, imageId]);

  useEffect(() => {
    if (!imageUrl && status === "idle" && allowGeneration) {
      requestImage();
    }
  }, [imageUrl, status, allowGeneration, requestImage]);

  return (
    <div className="relative">
      {status === "ready" && imageUrl ? (
        <img src={imageUrl} alt="Story illustration" className="rounded-2xl w-full shadow-sm" />
      ) : !allowGeneration ? (
        <div className="rounded-2xl border border-dashed border-slate-200 bg-white/70 p-4 text-center space-y-2">
          <p className="text-sm text-slate-500">Illustration will appear once the creator publishes it.</p>
        </div>
      ) : (
        <div className="rounded-2xl border border-dashed border-slate-200 bg-white/70 p-4 text-center space-y-3">
          <p className="text-sm text-slate-500">
            {status === "loading"
              ? "Painting this scene..."
              : errorMessage || "Tap below to create this illustration."}
          </p>
          <button
            onClick={requestImage}
            disabled={status === "loading"}
            className="px-4 py-2 rounded-full bg-indigo-600 text-white text-sm font-semibold hover:bg-indigo-700 disabled:opacity-60"
          >
            {status === "loading" ? "Creating..." : status === "error" ? "Try again" : "Generate illustration"}
          </button>
        </div>
      )}
    </div>
  );
};

export default ImageSection;
